function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { DocumentPicker } from "../../../../@/DocumentPicker";
import React from 'react';
import { Button, Layout, ListItem, List } from "../../../native";
import * as R from 'unitx/ramda';
import { useFormContext } from "../FormContext";

function FileInfoList(props) {
  const {
    fileInfoList,
    listKey
  } = props;
  return R.ifElse(R.isPositiveZero, () => null, () => /*#__PURE__*/React.createElement(List, {
    listKey: listKey,
    data: fileInfoList,
    renderItem: ({
      item: {
        name,
        size,
        type
      }
    }) => /*#__PURE__*/React.createElement(ListItem, {
      title: name,
      description: `${type} ${size} bytes`
    }),
    keyExtractor: (_, index) => `${index}`
  }))(fileInfoList.length);
}

function processFile(fileInfo) {
  const {
    name,
    size,
    type
  } = fileInfo;
  return new Promise((resolve, reject) => {
    const reader = new window.FileReader();
    reader.onerror = reject;

    reader.onload = event => {
      resolve({
        // @ts-ignore
        uri: event.target.result,
        name,
        size,
        type
      });
    }; // @ts-ignore


    reader.readAsDataURL(fileInfo);
  });
}

const processFiles = fileInfoList => Promise.all([].map.call(fileInfoList, processFile));

function TextWidget({
  id,
  readonly,
  disabled,
  // label,
  value,
  onChange,
  onBlur,
  onFocus,
  options,
  multiple,
  formContext
}) {
  const [state, setState] = React.useState({
    fileInfoList: []
  });
  const {
    mapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Button, _extends({}, mapping.button, {
    style: [mapping.button.style],
    disabled: disabled || readonly,
    onBlur: () => onBlur(id, value),
    onFocus: () => onFocus(id, value),
    onPress: async () => {
      // @ts-ignore
      const {
        type,
        output
      } = await DocumentPicker.getDocumentAsync(_objectSpread(_objectSpread({}, options), {}, {
        multiple
      }));
      return R.when(R.equals('success'), () => {
        processFiles(output).then(newFileInfoList => {
          setState({
            fileInfoList: newFileInfoList
          });
          onChange(multiple ? R.map(R.prop('uri'))(newFileInfoList) : newFileInfoList[0].uri);
        });
      })(type);
    }
  }), "Choose"), /*#__PURE__*/React.createElement(FileInfoList, {
    listKey: `list-${id}`,
    fileInfoList: state.fileInfoList
  }));
}

export default TextWidget;